import { render } from "./accountSettings.vue?vue&type=template&id=1aae9c44&scoped=true"
import script from "./accountSettings.vue?vue&type=script&lang=js"
export * from "./accountSettings.vue?vue&type=script&lang=js"

import "./accountSettings.vue?vue&type=style&index=0&id=1aae9c44&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/yf-sassmc4ct_wyf-saas-web_master/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aae9c44"]])

export default __exports__